import React, { useState } from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import BilledFilters from "@/modules/reports/billables/status/billed/filters";
import CommonTable from "components/list/table";
import {
  getChildData,
  getChildColumns,
  getBillableFiltersFromCompanyFilters,
} from "@/modules/reports/billables/status/child-table-config";

const BilledBillables = () => {
  const [filters, setFilters] = useState({
    contacts: {
      projects: {
        jobs: {
          billables: {
            status: {
              _eq: "billed",
            },
          },
        },
      },
    },
  });

  return (
    <div>
      <CompanyBasedBillableListing
        title="Billed Billables"
        status="billed"
        onFiltersChange={setFilters}
        filters={BilledFilters}
        sortOrder="asc"
        sortBy="contacts.projects.jobs.billables.forecast_date"
        enableAccordion={true}
        renderExpandedRow={(row) => (
          <div className="border rounded-md overflow-hidden bg-background">
            <CommonTable
              data={getChildData(row, "billed")}
              columns={getChildColumns("billed")}
              showHeader={true}
            />
          </div>
        )}
        renderContent={() => (
          <StatsSection
            status="billed"
            filters={getBillableFiltersFromCompanyFilters(filters)}
          />
        )}
        statusWiseFilters={{
          contacts: {
            projects: {
              jobs: {
                billables: {
                  status: {
                    _eq: "billed",
                  },
                },
              },
            },
          },
        }}
      />
    </div>
  );
};

export default BilledBillables;
